"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorMessageComponent = void 0;
class ErrorMessageComponent {
    isObject(value) {
        return value != null && Array.isArray(value);
    }
}
exports.ErrorMessageComponent = ErrorMessageComponent;
//# sourceMappingURL=errormessage.component.js.map